import React, { useState } from 'react';
import MotifInput from '@ey/motif-react-wrapper/Input';
import MotifFormField from '@ey/motif-react-wrapper/FormField';
import MotifErrorMessage from '@ey/motif-react-wrapper/ErrorMessage';
import MotifLabel from '@ey/motif-react-wrapper/Label';
import { labels } from '../../../util/uiconstants';
import styled from 'styled-components';
import { MotifIcon } from '@ey-xd/motif-react';
import { IconoirWarningCircle } from '@ey-xd/motif-icon';
import { ticketNumberRegex } from '../../../util/uiconstants';
import { validateTicketNumber } from './util';

// All
const TicketFieldWrapper = styled.section`

`;

function TicketField(props) {
    const {
        ticketNumber,
        onTicketChanged,
        showValidation,
        validationMessage
    } = props;

    const showError = !validateTicketNumber(ticketNumber) && showValidation;
    const errorText = validationMessage ?? labels.validationMessage;
    const [errorMesage, setErrorMesage] = useState(errorText);

    const handleTicketChange = (event) => {
        const ticket = event.target.value;
        const isInvalidTicket = ticket && !ticketNumberRegex.test(ticket);
        setErrorMesage(isInvalidTicket ? labels.ticketNumberRegexLabel : errorText);
        onTicketChanged(event);
    }

    return (
        <TicketFieldWrapper className='ticketdetail'>
            <section className="description motif-body1-default-regular">{labels.confirmationMessage}</section>
            <MotifFormField>
                <MotifLabel position='in'>{labels.ticketNumberLabel}</MotifLabel>
                <MotifInput
                    labelPosition="in"
                    value={ticketNumber}
                    maxLength={50}
                    clearButtonTitle={labels.clear}
                    onChange={handleTicketChange}
                    suffix={showError ? <MotifIcon fill="var(--red-600)" size="20" src={IconoirWarningCircle} /> : null}
                />
                {showError && (
                    <MotifErrorMessage>
                        {errorMesage}
                    </MotifErrorMessage>
                )}
            </MotifFormField>
        </TicketFieldWrapper>
    );
}

export default TicketField;
